import { DriverDetailsResponse, GetHubsOfCity } from "@/central-atoms/everest-fleet-pwa/responses";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DriverDetails = {
  details: DriverDetailsResponse | null,
  hubsOfCity: GetHubsOfCity | null
}

const initialState: DriverDetails = {
  details: null,
  hubsOfCity: null
};

const driverDetailsSlice = createSlice({
  name: "driverDetails",
  initialState,
  reducers: {
    setHubsOfCity: (state, action: PayloadAction<GetHubsOfCity>) => {
      state.hubsOfCity = action.payload;
    },
    setDriverDetails: (state, action: PayloadAction<DriverDetailsResponse>) => {
      state.details = action.payload;
    },
  },
});

export const { setDriverDetails, setHubsOfCity } = driverDetailsSlice.actions;
export default driverDetailsSlice.reducer;
